import { render, staticRenderFns } from "./ReportManagement.vue?vue&type=template&id=6a972b4c&scoped=true&"
import script from "./ReportManagement.vue?vue&type=script&lang=js&"
export * from "./ReportManagement.vue?vue&type=script&lang=js&"
import style0 from "./ReportManagement.vue?vue&type=style&index=0&id=6a972b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a972b4c",
  null
  
)

export default component.exports